export interface INotification {
    from: string;
    to: string;
    message: string;
}

type Environments = "Development" | "Test" | "Prod";

export type INotificationByEnv = {
    [env in Environments]: INotification;
};

export const NOTIFICATIONS_BY_ENV: INotificationByEnv = {
    Development: {
        from: "2024-10-23T16:30",
        to: "'2024-11-08T16:00",
        message:
            "Please be aware that Data Shop will be unavailable on 8th of November, 2024 - between 01:00 p.m. and 04:00 p.m."
    },
    Test: {
        from: "2024-10-24T00:00",
        to: "'2024-11-08T16:00",
        message:
            "Please be aware that Data Shop will be unavailable on 8th of November, 2024 - between 01:00 p.m. and 04:00 p.m."
    },
    Prod: {
        from: "2024-11-01T00:00",
        to: "'2024-11-08T16:00",
        message:
            "Please be aware that Data Shop will be unavailable on 8th of November, 2024 - between 01:00 p.m. and 04:00 p.m."
    }
};
